import { inject } from '@angular/core';
import { CanDeactivateFn } from '@angular/router';
import { CambiosPendientesService } from '../core/services/cambios-pendientes.service';

/**
 * Salir con cambios sin guardar pregunta antes (26/10/2026).
 *
 * Al dejar el proyecto lo pendiente se tiraba sin avisar: alguien cargaba una
 * DdV, iba al Dashboard y la perdía. Las pantallas con su propia barra (como
 * Planificar asignación) dicen si tienen algo con `hayCambios`.
 */
export const cambiosSinGuardarGuard: CanDeactivateFn<{ hayCambios?: () => boolean }> = (componente) => {
  const pendientes = inject(CambiosPendientesService);

  const propios = componente?.hayCambios?.() ?? false;
  const n = pendientes.guardando() ? 0 : pendientes.cantidad();

  if (!propios && n === 0) return true;

  const texto = propios || n !== 1 ? 'Hay cambios sin guardar' : 'Hay un cambio sin guardar';

  return window.confirm(`${texto}. Si salís, se pierden. ¿Salir igual?`);
};
